import type { Partner } from "../partners.ts";

let modal: HTMLElement | null = null;

export function closePartner(): void {
  modal?.remove();
  modal = null;
}

// A partner's voter tools as a readable modal: clickable links that open in a
// new tab. Opened from the "Herramientas de …" proximity button.
export function openPartner(p: Partner): void {
  closePartner();

  const overlay = document.createElement("div");
  overlay.className =
    "fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4";
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closePartner();
  });

  const card = document.createElement("div");
  card.className =
    "flex max-h-[90vh] w-full max-w-md flex-col gap-3 overflow-auto rounded-2xl border-2 border-black bg-white p-5 shadow-2xl";

  const head = document.createElement("div");
  head.className = "flex items-center gap-3";
  const logo = document.createElement("img");
  logo.src = p.logo;
  logo.alt = p.name;
  logo.className = "h-10 max-w-[60%] object-contain";
  const close = document.createElement("button");
  close.className =
    "ml-auto rounded-lg border-2 border-black px-3 py-1 font-bold";
  close.textContent = "Cerrar ✕";
  close.addEventListener("click", closePartner);
  head.append(logo, close);

  const intro = document.createElement("p");
  intro.className = "text-sm opacity-70";
  intro.textContent = "Herramientas para ayudarte a decidir tu voto:";

  card.append(head, intro);

  if (p.resources.length) {
    const list = document.createElement("div");
    list.className = "flex flex-col gap-2";
    for (const r of p.resources) {
      const a = document.createElement("a");
      a.href = r.url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.className =
        "flex items-center justify-between gap-2 rounded-xl border-2 border-black px-4 py-2 font-bold hover:bg-black/5";
      const label = document.createElement("span");
      label.textContent = r.title;
      const arrow = document.createElement("span");
      arrow.textContent = "↗";
      a.append(label, arrow);
      list.appendChild(a);
    }
    card.appendChild(list);
  } else {
    const empty = document.createElement("p");
    empty.className = "text-sm";
    empty.textContent = "Herramientas en preparación.";
    card.appendChild(empty);
  }

  if (p.url) {
    const site = document.createElement("a");
    site.href = p.url;
    site.target = "_blank";
    site.rel = "noopener noreferrer";
    site.className = "text-center text-xs underline opacity-60";
    site.textContent = `Visita ${p.name} ↗`;
    card.appendChild(site);
  }

  overlay.appendChild(card);
  document.body.appendChild(overlay);
  modal = overlay;
}
